/**
 * Geração de CSV no formato que o Excel em pt-BR abre sem ajuda: separador ";"
 * (a vírgula já é o separador decimal, então com "," o Excel joga tudo numa
 * coluna só) e BOM UTF-8 no início, sem o qual os acentos vêm quebrados.
 *
 * Mesmo formato usado na exportação de erros de Pix
 * (src/features/liquidation/pages/error-pix).
 */

type CelulaCsv = string | number | null | undefined;

/** Sempre entre aspas, com as aspas internas dobradas — regra do RFC 4180. */
export const csvCell = (value: CelulaCsv): string =>
  `"${String(value ?? "").replace(/"/g, '""')}"`;

/** Valor em centavos -> "175,12" (número que o Excel pt-BR já entende) */
export const centavosParaCsv = (cents: number): string =>
  (cents / 100).toFixed(2).replace(".", ",");

/** Linhas -> texto CSV completo, pronto para virar arquivo. */
export const montarCsv = (linhas: CelulaCsv[][]): string =>
  "﻿" + linhas.map((linha) => linha.map(csvCell).join(";")).join("\r\n");

/** Monta o CSV e dispara o download no browser. */
export const baixarCsv = (linhas: CelulaCsv[][], nomeArquivo: string): void => {
  const url = URL.createObjectURL(
    new Blob([montarCsv(linhas)], { type: "text/csv;charset=utf-8;" })
  );
  const link = document.createElement("a");
  link.href = url;
  link.download = nomeArquivo;
  link.click();
  URL.revokeObjectURL(url);
};
